
import { defineComponent } from 'vue'

import RepoDetailMixin from '~/mixins/repoDetailMixin'

export default defineComponent({
  name: 'AddDefaultBranchModal',
  mixins: [RepoDetailMixin],
  props: {
    login: {
      type: String,
      required: true
    },
    //? This component is only for GSR and GSR doesn't support monorepo or nested subgroups
    //? So, repo name will always be same as repo displayName
    repoName: {
      type: String,
      required: true
    },
    repoId: {
      type: String,
      required: true
    },
    toml: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      gsrDefaultBranch: '',
      commitLoading: false
    }
  },
  methods: {
    async activateGSRRepo(): Promise<void> {
      this.commitLoading = true

      const { provider } = this.$route.params

      await this.triggerGSRActivation({
        config: this.toml,
        defaultBranchName: this.gsrDefaultBranch,
        repositoryId: this.repoId as string
      })

      await this.fetchBasicRepoDetails({
        provider,
        owner: this.login,
        name: this.repoName,
        refetch: true
      })

      setTimeout(() => {
        this.$router.push({
          path: `/${provider}/${this.login}/${this.repoName}`
        })
      }, 500)

      this.$emit('onActivate')

      this.commitLoading = false
    }
  }
})
